// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"301":"forum/components/MessagesPage","451":"forum/components/MessageComposer","619":"forum/components/DialogDropdownList"}[chunkId] + ".js";
};